import clsx from 'clsx';
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

// import { RootState } from '@/src/reducers/types';

import SectionLoader from '@/src/components/common/Elements/Spinner/SectionLoader/SectionLoader';
import { cn } from '@/src/util/ui';

import Item from './Item/Item';

const List = ({
  isLoading,
  onReplying,
  isReplyingTo,
  projectId,
  heightClasses = 'tw-h-[calc(100vh-340px)]',
}) => {
  const [selected, setSelected] = useState({
    id: null,
    type: null,
  });

  const comments = useSelector((state) => state.comments.list.list);
  const dispatch = useDispatch();

  const handleSelected = (data) => {
    setSelected({
      id: null,
      type: null,
    });

    dispatch({
      type: 'SET_FILE_ACTION_COMMENTS',
      action: data.type,
      data: {},
    });

    setSelected(data);
  };

  if (isLoading) {
    return <SectionLoader className={clsx(heightClasses, 'tw-m-auto')} />;
  }

  if (!isLoading && comments.length === 0) {
    return (
      <p
        className={cn(
          'container--noRecords',
          'tw-w-full tw-flex-1',
          'tw-font-brandonTextBold tw-text-cfo-black ',
          heightClasses
        )}
      >
        No Records Found
      </p>
    );
  }

  return (
    <div
      className={clsx(
        'container--commentList',
        'tw-overflow-y-auto tw-scroll-styles',
        'tw-pr-[10px]',
        'tw-flex-1',
        heightClasses
      )}
    >
      {comments.map((comment) => (
        <div className="wrapper--commentItem" key={`fileCommentItem_${comment.id}`}>
          <Item
            comment={comment}
            onReplying={onReplying}
            isReplyingTo={isReplyingTo}
            projectId={projectId}
            selected={selected}
            handleSelected={handleSelected}
          />
          {comment.reply && comment.reply.length > 0 && (
            <div className="commentRepliesContainer">
              {comment.reply.map((reply) => (
                <Item
                  key={`fileCommentItem_${reply.id}`}
                  comment={reply}
                  onReplying={onReplying}
                  isReplyingTo={isReplyingTo}
                  projectId={projectId}
                  selected={selected}
                  handleSelected={handleSelected}
                />
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default List;
